module.exports = __webpack_public_path__ + "static/Kubota-1-365880ddd74082791ac4344ded78be73.jpg";